
























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button } from 'vant';
import VoteButton from '@/components/VoteButton.vue';
import SearchInput from '@/components/SearchInput.vue';
import { getVoteList } from '@/api/api';
import { namespace, State, Action, Mutation } from 'vuex-class';
import * as mutationTypes from '../store/mutation-types';
import { IState, HealthListParam } from '../store/types';
import * as config from '../config';

const Module = namespace('HealthContributionBrand2019');
Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Button);
@Component({
  components: {
    SearchInput,
    VoteButton,
  },
})
export default class VoteList extends Vue {
  @Module.State('healthList') healthListData!: object;
  @Module.State('finished') finished!: boolean;
  @Module.State('loading') healthLoading!: boolean;
  @Module.State('page') page!: number;
  @Module.State('searchPage') searchPage!: number;
  @Module.State('loadStatus') loadStatus!: number;
  @Module.State('button') button!: boolean;
  @Module.State('voteNum') votes!: number;
  @Module.Action gethealthList!: (param: HealthListParam) => void;
  @Module.Action searchHealthList!: (param: HealthListParam) => void;
  @Module.Action updateVoteNumber!: (val: any) => void;
  @Module.Mutation(mutationTypes.CLEAN_LIST_DATA) cleanData!: () => void;
  options = config.OPTHINES;
  result = [];
  SearchData = '';
  get loading() {
    return this.healthLoading;
  }
  set loading(val: boolean) {
    console.log('set', val);
  }

  // 初使加载
  onLoad() {
    if (this.loadStatus === 0) {
      this.gethealthList({
        type: this.$route.query.type,
        page: this.page,
      });
    } else {
      this.searchHealthList({
        type: this.$route.query.type,
        page: this.searchPage,
        search: this.SearchData,
      });
    }
  }
  votSuccess(votes: any) {
    this.updateVoteNumber(votes);
  }
  // 进入详情页
  enterDetailPage(item: any) {
    // this.cleanData();
    this.$router.push({
      path: './DetailPage',
      query: { id: item.id, type: this.$route.query.type },
    });
  }
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索
  startSearch() {
    this.cleanData();
    this.searchHealthList({
      type: this.$route.query.type,
      page: this.searchPage,
      search: this.SearchData,
    });
    setTimeout(() => {
      this.onLoad();
    }, 500);
  }
}
